export const defaultLanguageCode = "it";
